import LOCALE_EN_COMMON from '@intelligence/_locales/en-US/common';
import LOCALE_ZH_COMMON from '@intelligence/_locales/zh-CN/common';
import LOCALE_EN_METRIC from '@intelligence/_locales/en-US/metric';
import LOCALE_ZH_METRIC from '@intelligence/_locales/zh-CN/metric';
import { DATASOURCE_KEY_MAP, COMMON_METRIC_KEY_MAP, SENSORTOWER_METRIC_KEY_MAP } from './keyMap';

/**
 * mobile平台信息配置
 */
export const MOBILE_PLATFORM: IDBIPlatform = {
  platform: 'mobile',
  platformName: {
    en: LOCALE_EN_COMMON.dbi_mobile,
    cn: LOCALE_ZH_COMMON.dbi_mobile,
  },
};

/**
 * mobile平台数据源信息配置
 */
export const MOBILE_DATA_SOURCES_MAPPING: IRecord<IDBIDataSource> = {
  [DATASOURCE_KEY_MAP.OGDB]: {
    dataSource: DATASOURCE_KEY_MAP.OGDB,
    dataSourceJump: 'databarin',
    dataSourceName: {
      en: LOCALE_EN_COMMON.dbi_dataBrain_calibration,
      cn: LOCALE_ZH_COMMON.dbi_dataBrain_calibration,
    },
  },
  [DATASOURCE_KEY_MAP.SENSORTOWER]: {
    dataSource: DATASOURCE_KEY_MAP.SENSORTOWER,
    dataSourceJump: 'sensortower',
    dataSourceName: {
      en: 'Sensor Tower',
      cn: 'Sensor Tower',
    },
  },
  [DATASOURCE_KEY_MAP.APP_ANNIE]: {
    dataSource: DATASOURCE_KEY_MAP.APP_ANNIE,
    dataSourceJump: 'appannie',
    dataSourceName: {
      en: 'data.ai',
      cn: 'data.ai',
    },
  },
};

/**
 * mobile平台数据源指标配置
 */
export const MOBILE_DATA_SOURCES_METRICS_MAPPING: IRecord<IRecord<IDBIMetric>> = {
  [DATASOURCE_KEY_MAP.OGDB]: {
    [COMMON_METRIC_KEY_MAP.AU]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.OGDB],
      metric: 'au',
      metricJump: 'au',
      metricName: {
        en: 'au',
        cn: 'au',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [COMMON_METRIC_KEY_MAP.REVENUE]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.OGDB],
      metric: 'revenue',
      metricJump: 'revenue',
      metricName: {
        en: 'Revenue',
        cn: '收入(美元)',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [COMMON_METRIC_KEY_MAP.ARPU]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.OGDB],
      metric: 'arpu',
      metricJump: 'arpu',
      metricName: {
        en: 'ARPU',
        cn: '活跃ARPU',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [COMMON_METRIC_KEY_MAP.DOWNLOAD]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.OGDB],
      metric: 'download',
      metricJump: 'download',
      metricName: {
        en: 'Downloads',
        cn: '下载',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
  },
  [DATASOURCE_KEY_MAP.SENSORTOWER]: {
    [COMMON_METRIC_KEY_MAP.AU]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.SENSORTOWER],
      metric: 'au',
      metricJump: 'au',
      metricName: {
        en: 'au',
        cn: 'au',
      },
      explanation: null,
    },
    [COMMON_METRIC_KEY_MAP.REVENUE]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.SENSORTOWER],
      metric: 'revenue',
      metricJump: 'revenue',
      metricName: {
        en: 'Revenue',
        cn: '收入(美元)',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [COMMON_METRIC_KEY_MAP.ARPU]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.SENSORTOWER],
      metric: 'arpu',
      metricJump: 'arpu',
      metricName: {
        en: 'ARPU',
        cn: '活跃ARPU',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [COMMON_METRIC_KEY_MAP.DOWNLOAD]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.SENSORTOWER],
      metric: 'download',
      metricJump: 'download',
      metricName: {
        en: 'Downloads',
        cn: '下载',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.SENSORTOWER],
      metric: SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE,
      metricJump: 'cross_app_usage',
      metricName: {
        en: LOCALE_EN_METRIC.dbi_metric_mobile_cross_usage,
        cn: LOCALE_ZH_METRIC.dbi_metric_mobile_cross_usage,
      },
      explanation: {
        en: {
          definition: 'The percentage of users who use the app concurrently using the listed apps.',
          dataSource: 'Sensor Tower',
          granularity: LOCALE_EN_COMMON.dbi_monthly,
          aggregation: LOCALE_EN_COMMON.dbi_calculation_method_average,
          updateTime:
            '1 month delay; data for the previous month will be available at 2 AM UTC+0 on the 9th of each month.',
        },
        cn: {
          definition: '使用该应用的用户同时使用列表应用的百分比。',
          dataSource: 'Sensor Tower',
          granularity: LOCALE_ZH_COMMON.dbi_monthly,
          aggregation: LOCALE_ZH_COMMON.dbi_calculation_method_average,
          updateTime: '延时1个月，每月9日的2AM UTC+0 可以看到上个月的数据 ',
        },
      },
    },
    [SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.SENSORTOWER],
      metric: SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY,
      metricJump: 'cross_affinity',
      metricName: {
        en: LOCALE_EN_METRIC.dbi_metric_mobile_cross_affinity,
        cn: LOCALE_ZH_METRIC.dbi_metric_mobile_cross_affinity,
      },
      explanation: {
        en: {
          definition:
            'Compared to the general population, users of this app are multiple times more likely to use the listed apps.',
          dataSource: 'Sensor Tower',
          granularity: LOCALE_EN_COMMON.dbi_monthly,
          aggregation: LOCALE_EN_COMMON.dbi_calculation_method_average,
          updateTime:
            '1 month delay; data for the previous month will be available at 2 AM UTC+0 on the 9th of each month.',
        },
        cn: {
          definition: '与一般人群相比，此应用的使用者使用列表应用的可能性倍数。 ',
          dataSource: 'Sensor Tower',
          granularity: LOCALE_ZH_COMMON.dbi_monthly,
          aggregation: LOCALE_ZH_COMMON.dbi_calculation_method_average,
          updateTime: '延时1个月，每月9日的2AM UTC+0 可以看到上个月的数据 ',
        },
      },
    },
  },
  [DATASOURCE_KEY_MAP.APP_ANNIE]: {
    [COMMON_METRIC_KEY_MAP.AU]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.APP_ANNIE],
      metric: 'au',
      metricJump: 'au',
      metricName: {
        en: 'au',
        cn: 'au',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [COMMON_METRIC_KEY_MAP.REVENUE]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.APP_ANNIE],
      metric: 'revenue',
      metricJump: 'revenue',
      metricName: {
        en: 'Revenue',
        cn: '收入(美元)',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [COMMON_METRIC_KEY_MAP.ARPU]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.APP_ANNIE],
      metric: 'arpu',
      metricJump: 'arpu',
      metricName: {
        en: 'ARPU',
        cn: '活跃ARPU',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
    [COMMON_METRIC_KEY_MAP.DOWNLOAD]: {
      ...MOBILE_PLATFORM,
      ...MOBILE_DATA_SOURCES_MAPPING[DATASOURCE_KEY_MAP.APP_ANNIE],
      metric: 'download',
      metricJump: 'download',
      metricName: {
        en: 'Downloads',
        cn: '下载',
      },
      explanation: {
        en: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
        cn: () => {
          return {
            definition: '',
            dataSource: '',
            granularity: '',
            aggregation: '',
            updateTime: '',
          };
        },
      },
    },
  },
};
